import { createContext } from 'react';

import { ConnectorType, Metric, Split } from '../../utils/gql/types';

export interface ConnectorsContextType {
  ready: boolean;
  propertyId: string;
  analyticsAccountLoading: boolean;
  accountsLoading: boolean;
  clientAccountId: string;
  googleAdsConnectorId?: string;
  shopifyConnectorId?: string;
  facebookConnectorId?: string;
  googleAnalytics4ConnectorId?: string;
  googleSearchConsoleConnectorId?: string;
  searchConsoleSiteUrl?: string;
  databaseConnectorId?: string;
  magentoConnectorId?: string;
  magentoConnectorEnabled?: boolean;
  shopifyMetrics: Metric[];
  facebookMetrics: Metric[];
  googleAdsMetrics: Metric[];
  googleAnalyticsMetrics: Metric[];
  googleSearchConsoleMetrics?: Metric[];
  magentoMetrics?: Metric[];
  databaseMetrics?: Metric[];
  gettingFacebookMetrics: boolean;
  gettingShopifyMetrics: boolean;
  gettingMagentoMetrics?: boolean;
  gettingGoogleAdsMetrics: boolean;
  gettingGoogleAnalyticsMetrics: boolean;
  gettingGoogleSearchConsoleMetrics?: boolean;
  gettingDatabaseMetrics?: boolean;
  splits: Split[];
  dbSplits?: Split[];
  databaseJoinEdges?: Array<{ tableA: string; tableB: string }>;
  databaseMainTables?: string[];
  shouldRedirect?: boolean;
  isMetricEnabled?: (
    connectorType: ConnectorType,
    metricKey: string,
  ) => boolean;
}

export const defaultValue: ConnectorsContextType = {
  ready: false,
  propertyId: '',
  analyticsAccountLoading: false,
  accountsLoading: false,
  clientAccountId: '',
  shopifyMetrics: [],
  facebookMetrics: [],
  googleAdsMetrics: [],
  googleAnalyticsMetrics: [],
  googleSearchConsoleMetrics: [],
  gettingFacebookMetrics: false,
  gettingShopifyMetrics: false,
  gettingGoogleAdsMetrics: false,
  gettingGoogleAnalyticsMetrics: false,
  gettingGoogleSearchConsoleMetrics: false,
  splits: [],
};

export const ConnectorsContext =
  createContext<ConnectorsContextType>(defaultValue);

ConnectorsContext.displayName = 'ConnectorsContext';
